module.exports = __webpack_public_path__ + "static/media/phone-book.dff21610.svg";